import React from 'react';

const FeedBack = () => {
    return (
        <div className="">
            <label>FeedBack Form</label>
        </div>
    );
};

export default FeedBack;
